import "../styles/Service.css";
import { Typography, Button, AppBar, Toolbar, Grid2} from "@mui/material";
import logo from "../assets/LOGO.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Service = ()=>{
  const form = useRef();
  const [showPhoneModal, setShowPhoneModal] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    const formData = {
      user_name: form.current.user_name.value,
      phone: form.current.phone.value,
      alternate_phone: form.current.alternate_phone.value,
      email: form.current.email.value,
      vehicle_type: form.current.vehicle_type.value,
      comments: form.current.comments.value,
    };

    emailjs.send('service_riat5gd', 'YOUR_TEMPLATE_ID', formData, 'YKIZWeVRe6T9FLWqO')
      .then((result) => {
        console.log(result.text);
        alert('Mensaje enviado exitosamente!');
        form.current.reset(); // Limpiar el formulario después de enviar el correo exitosamente
      }, (error) => {
        console.error('Error al enviar el mensaje:', error);
        alert(`Hubo un error al enviar el mensaje: ${error.text}`);
      });
  };
  useEffect(() => {
      const hash = window.location.hash;
      if (hash === '#video-motores') {
        const element = document.getElementById('video-motores');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      if (hash === '#form-section-serv') {
        const element = document.getElementById('form-section-serv');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, []);
  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const center = {
    lat: 26.07687,
    lng: -80.21041,
  };
  const handleScroll = () => {
    document.getElementById('form-section-serv').scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        nextArrow: null,
        prevArrow: null,
      };
    return(
        <div className="Service">
            <div className="header-Service">
          <AppBar color="white">
            <Toolbar>
              <Grid2 container alignItems="center" className="header-Grid2">
                <Grid2 item>
                    <img className="logo" src={logo} alt="logo"/>
                    </Grid2>
                <Grid2 item>
                <Link to='/'><Button color="inherit" >Home</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/PartsEngineSales'><Button color="inherit" >Parts & Engine Sales</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='#'><Button color="inherit" > Service</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/OtherBrands'><Button color="inherit"> Other Brands</Button></Link>
                </Grid2>
                <Grid2 item>
                <Link to='/AboutUs'><Button color="inherit" > About US</Button></Link>
                </Grid2>
                <Grid2 item xs />
                <Grid2 item>
                <a href="mailto:fitoto9349@nalwan.com"><Button className="contact-button" >Contact Us</Button></a>
                </Grid2>
              </Grid2>
            </Toolbar>
          </AppBar>
        </div>
        <div className="body">
        <div className="video-container-motores" id="video-motores"> 
            <video className="custom-video-motores" controls autoPlay loop muted> 
              <source src={require("../assets/VIDEOS/VIDEO_MOTORES.mp4")} type="video/mp4" /> 
              Your browser does not support the video tag. 
            </video> 
        </div>
        <a href="https://wa.me/+17542622405" target="whatsapp" className="whatsapp-button">
          <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 256 258">
            <defs>
              <linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#1faf38"></stop>
                <stop offset="100%" stopColor="#60d669"></stop>
              </linearGradient>
              <linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#f9f9f9"></stop>
                <stop offset="100%" stopColor="#fff"></stop>
              </linearGradient>
            </defs>
            <path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"></path>
            <path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"></path>
            <path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"></path>
          </svg>
        </a>
        <div className="services-container">
            <p className="service-title-text">SERVICES</p>
            <hr /><hr />
            <p className="service-text framed-text">Expert Diesel has one of the finest service departments anywhere. Specializing in Cummins engines, we perform repairs on all brands, types and models of diesel engines. Whether it is marine, truck or industrial diesel engines, our technicians are able to diagnose your problem quickly and then repair it in as little time as possible. Our goal is to get you up and running as quickly as possible for LESS DOWNTIME.<br /><br />As a Certified Cummins and Autocar Warranty Repair Center, we are able to perform all warranty work on Cummins engines and Autocar Trucks.</p> <hr /><hr className="div-bot" />
        </div>
      <div className="services-section">
        <p className="serv-title">WHY CHOOSE OUR SERVICES</p>
        <Grid2 container className="services-Grid2" spacing={2}>
          <Grid2 item xs={12} md={4} className="service-card">
            <div className="service-card-content" onClick={handleScroll}>
            <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 24 24"><path fill="currentColor" d="M7 4v2h3v2H7l-2 2v3H3v-3H1v8h2v-3h2v3h3l2 2h8v-4h2v3h3V9h-3v3h-2V8h-6V6h3V4z"></path></svg>
              <p className="service-card-title">CERTIFIED ON ALL LEVELS OF CUMMINS ENGINES</p>
              <p className="service-card-text">WE ARE CERTIFIED ON ALL LEVELS OF CUMMINS ENGINES INCLUDING MARINE, INDUSTRIAL AND TRUCK.</p>
            </div>
          </Grid2>
          <Grid2 item xs={12} md={4} className="service-card">
            <div className="service-card-content" onClick={handleScroll}>
            <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 26 26"><path fill="currentColor" d="M1.313 0L0 1.313l2.313 4l1.5-.22l9.156 9.157l-.781.75c-.4.4-.4 1.006 0 1.406l.406.407c.4.4 1.012.4 1.312 0L15.094 18c-.1.6 0 1.313.5 1.813L21 25.188c1.1 1.1 2.9 1.1 4 0c1.3-1.2 1.288-2.994.188-4.094l-5.375-5.407c-.5-.5-1.213-.7-1.813-.5L16.687 14c.3-.4.3-1.012 0-1.313l-.375-.374a.974.974 0 0 0-1.406 0l-.656.656l-9.156-9.156l.218-1.5l-4-2.313zm19.5.031C18.84-.133 16.224 1.175 15 2.312c-1.506 1.506-1.26 3.475-.063 5.376l-2.124 2.125l1.5 1.687c.8-.7 1.98-.7 2.78 0l.407.406l.094.094l.875-.875c1.808 1.063 3.69 1.216 5.125-.219c1.4-1.3 2.918-4.506 2.218-6.406L23 7.406c-.4.4-1.006.4-1.406 0L18.687 4.5a.974.974 0 0 1 0-1.406L21.595.188c-.25-.088-.5-.133-.782-.157m-11 12.469l-3.626 3.625A5.3 5.3 0 0 0 5 16c-2.8 0-5 2.2-5 5s2.2 5 5 5s5-2.2 5-5c0-.513-.081-1.006-.219-1.469l2.125-2.125l-.312-.406c-.8-.8-.794-2.012-.094-2.813L9.812 12.5zm7.75 4.563c.125 0 .243.024.343.125l5.907 5.906c.2.2.2.518 0 .718s-.52.2-.72 0l-5.905-5.906c-.2-.2-.2-.518 0-.718c.1-.1.25-.125.375-.125M5.688 18.405l1.906 1.907l-.688 2.593l-2.593.688l-1.907-1.907l.688-2.593z"></path></svg>
              <p className="service-card-title">AUTHORIZE CUMMINS SERVICE CENTER</p>
              <p className="service-card-text">WE ARE AN AUTHORIZE CUMMINS SERVICE CENTER AND AUTOCAR SERVICE CENTER, CAPABLE OF WORKING ON ALL ENGINE TYPES AND SIZES FROM THE LITTLE BS TO THE BIG QSKS.</p>
            </div>
          </Grid2>
          <Grid2 item xs={12} md={4} className="service-card">
            <div className="service-card-content" onClick={handleScroll}>
            <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 32 32"><path fill="currentColor" d="m16 30l-6.176-3.293A10.98 10.98 0 0 1 4 17V4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v13a10.98 10.98 0 0 1-5.824 9.707ZM6 4v13a8.99 8.99 0 0 0 4.766 7.942L16 27.733l5.234-2.79A8.99 8.99 0 0 0 26 17V4Z"></path><path fill="currentColor" d="M16 25.277V6h8v10.805a7 7 0 0 1-3.7 6.173Z"></path></svg>
              <p className="service-card-title">WARRANTY PROTECTION</p>
              <p className="service-card-text">AS A CERTIFIED CUMMINS AND AUTOCAR WARRANTY REPAIR CENTER, WE ARE ABLE TO PERFORM ALL WARRANTY WORK ON CUMMINS ENGINES AND AUTOCAR TRUCKS.</p>
            </div>
          </Grid2>
          <Grid2 item xs={12} md={4} className="service-card">
            <div className="service-card-content" onClick={handleScroll}>
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 16 16">
              <path fill="currentColor" d="M11.8 6.13a.683.683 0 0 0-.11-.973a.715.715 0 0 0-.992.108l-3.31 4.06l-1.77-1.36a.715.715 0 0 0-.994.089a.683.683 0 0 0 .09.975l2.32 1.81a.715.715 0 0 0 1.003-.1l3.76-4.62z"></path>
              <path fill="currentColor" fillRule="evenodd" d="M6.51.714C7.044.322 7.311.126 7.6.05a1.6 1.6 0 0 1 .787 0c.292.076.56.272 1.09.664l.677.497c.185.136.278.204.378.257q.134.07.279.116c.109.033.222.05.449.085l.83.127c.655.1.982.151 1.24.304c.23.135.422.327.557.557c.153.26.203.588.304 1.24l.127.83c.035.227.052.341.085.45q.045.145.116.278c.054.1.121.193.257.378l.497.677c.392.534.588.801.664 1.09a1.6 1.6 0 0 1 0 .787c-.075.292-.272.56-.664 1.09l-.497.677a3 3 0 0 0-.257.378a1.6 1.6 0 0 0-.116.28c-.033.108-.05.221-.085.448l-.127.83c-.1.655-.151.982-.304 1.24c-.135.23-.327.421-.557.557c-.26.153-.588.203-1.24.304l-.83.127a3 3 0 0 0-.449.086q-.145.044-.279.116c-.1.053-.193.12-.378.257l-.677.497c-.534.392-.801.588-1.09.664a1.6 1.6 0 0 1-.787 0c-.292-.076-.56-.272-1.09-.664l-.677-.497a3 3 0 0 0-.378-.257a1.6 1.6 0 0 0-.279-.116a3 3 0 0 0-.449-.086l-.83-.127c-.655-.1-.983-.15-1.24-.304a1.6 1.6 0 0 1-.557-.557c-.153-.26-.203-.588-.304-1.24l-.127-.83c-.035-.227-.052-.34-.085-.449a1.5 1.5 0 0 0-.116-.279a3 3 0 0 0-.257-.378l-.497-.677c-.392-.534-.588-.8-.664-1.09a1.6 1.6 0 0 1 0-.787c.075-.292.272-.56.664-1.09l.497-.677c.136-.185.204-.278.257-.378q.07-.134.116-.279c.033-.109.05-.222.085-.449l.127-.83c.1-.655.151-.983.304-1.24c.135-.23.327-.42.557-.557c.26-.153.588-.203 1.24-.304l.83-.127c.227-.034.341-.052.449-.085q.145-.045.279-.116c.1-.053.193-.121.378-.257zm2.38.806l.711.522c.151.111.3.22.466.309q.22.117.456.189a4 4 0 0 0 .548.111l.872.134c.741.114.833.145.887.177q.127.076.202.202c.032.054.064.146.177.887l.134.872a4 4 0 0 0 .111.548q.073.238.189.456c.088.166.198.315.309.466l.522.711c.444.604.486.691.502.753a.6.6 0 0 1 0 .286c-.016.061-.058.148-.502.753l-.522.711c-.111.151-.221.3-.309.466a2.6 2.6 0 0 0-.189.456a4 4 0 0 0-.111.548l-.134.872c-.114.741-.145.833-.177.887a.6.6 0 0 1-.202.202c-.054.032-.146.064-.887.177l-.872.134a4 4 0 0 0-.548.111a2.6 2.6 0 0 0-.456.189c-.166.088-.315.198-.466.309l-.711.522c-.604.444-.691.486-.753.502a.6.6 0 0 1-.286 0c-.061-.016-.148-.058-.753-.502l-.711-.522a4 4 0 0 0-.466-.309a2.6 2.6 0 0 0-.456-.189a4 4 0 0 0-.548-.111l-.872-.134c-.741-.114-.833-.145-.887-.177a.6.6 0 0 1-.202-.202c-.032-.054-.064-.146-.177-.887l-.134-.872a4 4 0 0 0-.111-.548a2.6 2.6 0 0 0-.189-.456c-.088-.166-.198-.315-.309-.466l-.522-.711c-.444-.604-.486-.691-.502-.753a.6.6 0 0 1 0-.286c.016-.061.058-.148.502-.753l.522-.711c.111-.151.221-.3.309-.466q.116-.22.189-.456a4 4 0 0 0 .111-.548l.134-.872c.114-.741.145-.833.177-.887a.6.6 0 0 1 .202-.202c.054-.032.146-.064.887-.177l.872-.134a4 4 0 0 0 .548-.111q.238-.073.456-.189c.166-.088.315-.198.466-.309l.711-.522c.604-.444.691-.486.753-.502a.6.6 0 0 1 .286 0c.061.016.148.058.753.502" clipRule="evenodd"></path>
            </svg>
              <p className="service-card-title">TRAINED TECHNICIANS</p>
              <p className="service-card-text">WE ALWAYS HAVE OVER 20 FULL-TIME TRAINED TECHNICIANS AND PARTS PERSNNEL ON STAFF READY TO MEET YOUR NEEDS.</p>
            </div>
          </Grid2>
          <Grid2 item xs={12} md={4} className="service-card">
            <div className="service-card-content" onClick={handleScroll}>
            <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 2048 2048"><path fill="currentColor" d="M1920 128v1792H128V128zM256 256v1024h150l109-109q19-19 45-19t45 19l177 176l244-947q5-21 22-34t40-14q23 0 40 13t22 36l102 417h156q22 0 39 13t23 35l72 286h250V256zm1536 1536v-512h-300q-23 0-40-13t-22-36l-72-285h-156q-23 0-40-13t-22-36l-54-218l-208 809q-5 21-22 34t-40 14q-26 0-45-19l-211-211l-83 83q-19 19-45 19H256v384z"></path></svg>
              <p className="service-card-title">PROFESSIONAL DIAGNOSE</p>
              <p className="service-card-text">WHETER IT IS MARINE, TRUCK OR INDUSTRIAL DIESEL ENGINES, OUR TECHNICIANS ARE ABLE TO DIAGNOSE YOUR PROBLEM QUICKLY AND THEN REPAIR IT IN AS LITTLE TIME AS POSIBLE.</p>
            </div>
          </Grid2>
          <Grid2 item xs={12} md={4} className="service-card">
            <div className="service-card-content" onClick={handleScroll}>
            <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 24 24"><path fill="currentColor" d="M20 17h3l-4 4l-4-4h3V3h2zM8 5c-3.86 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7s-3.13-7-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85S10.68 16.85 8 16.85S3.15 14.68 3.15 12S5.32 7.15 8 7.15M7 9v3.69l3.19 1.84l.75-1.3l-2.44-1.41V9"></path></svg>
              <p className="service-card-title">LESS DOWNTIME</p>
              <p className="service-card-text">OUR GOAL IS TO GET YOU UP AND RUNNING AS QUICKLY AS POSSIBLE FOR LESS DOWNTIME.</p>
            </div>
          </Grid2>
        </Grid2>
      </div>
      <Slider {...settings}>
        <div className="slider">
              <img src={require("../assets/_W3A7184.jpg")} alt="Expert Dieselt" />
            </div>
            <div>
              <img src={require("../assets/_W3A6882.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A6901.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7017.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7039.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A6845.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7044.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7204-Edit.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A6955.jpg")} alt="Expert Diesel" />
            </div>
            <div>
              <img src={require("../assets/_W3A7029.jpg")} alt="Expert Diesel" />
            </div>
      </Slider>
      <p className="form-title-serv">REQUEST A SERVICE</p>
      <div className="form-section" id="form-section-serv">
      <form ref={form} onSubmit={sendEmail}>
        <Grid2 container>
          <Grid2 item xs={12} md={4} className="Grid2-item-service">
            <p className="contact-info-title-serv">CONTACT INFORMATION</p>
            <hr className="form-division-serv"/>
            <div className="form-group-serv">
              <p className="tittles-serv">NAME:*</p>
              <input type="text" name="user_name" placeholder="Name" required />
            </div>
            <div className="form-group-serv">
              <p className="tittles-serv">PHONE:*</p>
              <input type="text" name="phone" placeholder="Phone Number" required />
            </div>
            <div className="form-group-serv">
              <p className="tittles-serv">ALTERNATE PHONE:</p>
              <input type="text" name="alternate_phone" placeholder="Alternate Phone Number" />
            </div>
            <div className="form-group-serv">
              <p className="tittles-serv">EMAIL:*</p>
              <input type="text" name="email" placeholder="Email" required />
            </div>
          </Grid2>    
          <Grid2 item xs={12} md={3} className="Grid2-item-service">
            <p className="contact-info-title-serv">VEHICLE INFORMATION</p>
            <hr className="form-division-serv"/>
            <div className="form-group-serv">
              <p className="tittles-serv">VEHICLE TYPE:*</p>
              <input type="text" name="vehicle_type" placeholder="Vehicle Type" required />
            </div>
            <div className="form-group-serv">
              <p className="tittles-serv">COMMENTS</p>
              <input type="text" name="comments" placeholder="SOME OBSERVATIONS" />
            </div>
            <button type="submit" className="send-button-serv">SEND</button>
          </Grid2>
        </Grid2>
      </form>
    </div>
      <div className="footer">
      <Grid2 container spacing={2} className="footer-container">
        <Grid2 item xs={12} md={6} className="footer-right">
              <div className="map-container">
                <LoadScript googleMapsApiKey="AIzaSyBN6CqhMJnBIJnFR2NwAFBC4ya2XdHVKoc">
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={center}
                    zoom={14}
                  >
                    <Marker position={center} title="My location" />
                  </GoogleMap>
                  <div className="map-info">
                    <p className='map-text'>EXPERT DIESEL | 4700 OAKES RD | HOLLYWOOD, FL 33314</p>
                    <h6 className='call-us-text'>CALL US TODAY AT 954-583-2400 FOR MORE INFORMATION!!</h6>
                  </div>
                </LoadScript>
              </div>
            </Grid2>
            <Grid2 item xs={12} md={6} className="footer-left">
              <Typography variant="h4" className="some-our-main">SOME OUR MAIN CUSTOMERS</Typography>
              <Typography variant="h6" className="some-our-text">We provide Cummins, Autocar and diesel engine service and repairs for all of South Florida, including the following counties and cities:</Typography>
              <Typography variant="h6" className="some-our-list">
                <Grid2 container className="list">
                  <Grid2 item xs={6}>
                    <ul>
                      <li>Broward County</li>
                      <li>Miami-Dade County</li>
                      <li>Fort Lauderdale</li>
                      <li>Plantation</li>
                      <li>Sunrise</li>
                      <li>Pembroke Pines</li>
                      <li>Cooper City</li>
                      <li>Davie</li>
                      <li>Coral Springs</li>
                      <li>Tamarac</li>
                      <li>Boca Raton</li>
                    </ul>
                  </Grid2>
                  <Grid2 item xs={6}>
                    <ul>
                      <li>Delray Beach</li>
                      <li>Deerfield Beach</li>
                      <li>Pompano Beach</li>
                      <li>Hollywood</li>
                      <li>Aventura</li>
                      <li>North Miami Beach</li>
                      <li>Kendall</li>
                      <li>Miami Beach</li>
                      <li>Miami</li>
                      <li>Key Biscayne</li>
                      <li>Many more!!!</li>
                    </ul>
                  </Grid2>
                </Grid2>
              </Typography>
            </Grid2>
          </Grid2>
          </div>
      <div className="connect-with-us">
      <Typography variant="h4">CONNECT WITH US</Typography>
            {showPhoneModal && (
            <div className="aviso">
              <div className="aviso-content">
                <button className="close-btn-aviso" onClick={() => setShowPhoneModal(false)}>
                  &times;
                </button>
                <p className="aviso-title">CONTACT</p>
                <p className="aviso-text">Our contact number is: +1 (954)-583-2400</p>
              </div>
            </div>
          )}
          <Grid2 container spacing={2}>
            <Grid2 item xs={12} md={4} className="logo-section" onClick={() => setShowPhoneModal(true)} style={{ cursor: 'pointer', textAlign: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4c1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10"></path></svg>
              <Typography variant="body1" style={{fontWeight:'bold', paddingTop:'10px'}}>GET SUPPORT</Typography>
            </Grid2>
            <hr className="logo-divider" />
            <Grid2 item xs={12} md={4} className="logo-section">
            <Link to="/PartsEngineSales#form-section" className="request-quote-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                <path fill="currentColor" d="M6 22q-.825 0-1.412-.587T4 20V4q0-.825.588-1.412T6 2h8l6 6v12q0 .825-.587 1.413T18 22zm5-3h2v-1h1q.425 0 .713-.288T15 17v-3q0-.425-.288-.712T14 13h-3v-1h4v-2h-2V9h-2v1h-1q-.425 0-.712.288T9 11v3q0 .425.288.713T10 15h3v1H9v2h2zm2.175-11h4l-4-4z"></path>
              </svg>
              <Typography variant="body1" style={{fontWeight:'bold', paddingTop:'10px'}}>REQUEST A QUOTE</Typography>
            </Link>
            </Grid2>
            <hr className="logo-divider" />
            <Grid2 item xs={12} md={4} className="logo-section">
              <Link to="#form-section-serv" onClick={handleScroll} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width={512} height={512} viewBox="0 0 512 512"><path fill="currentColor" d="M80.08 82.66L60.24 102.5L192.9 242.7v58.6h78v-50.9zm-25.4 40.14v80.3l4.01 2.7c10.56 7 14.74 14.1 15.93 19.8c1.18 5.8-.43 10.8-3.85 14.9c-6.86 8.3-19.91 12.3-32.73-.6l-12.72 12.8c19.18 19.1 46.13 15.1 59.27-.6c6.58-7.9 9.97-18.9 7.65-30.1c-2.05-10-8.72-19.7-19.56-28v-52.2zm258.02 52.5v144h-185c22.6 5.8 40.6 23.5 46.7 46H337c7.5-27.6 32.8-48 62.7-48s55.2 20.4 62.7 48h24.3v-84.6l-60.2-105.4zm36 14h62.1l54.7 92H348.7v-83zm-321.49 130l11.5 46h10.25c6.12-22.5 24.09-40.2 46.74-46zm84.49 16c-26.08 0-47.02 20.9-47.02 47s20.94 47 47.02 47c26.1 0 47-20.9 47-47s-20.9-47-47-47m288 0c-26.1 0-47 20.9-47 47s20.9 47 47 47s47-20.9 47-47s-20.9-47-47-47"></path></svg>
                <Typography variant="body1" style={{ fontWeight: 'bold', paddingTop: '10px' }}>
                  REQUEST A SERVICE
                </Typography>
              </Link>
            </Grid2>        
          </Grid2>
          <Typography variant="body1" className="connect-text"> © 2024 Expert diesel, Box 3005, Columbus, IN 47202-3005 U.S.A.</Typography>
          <Grid2 container spacing={2} className="social-buttons">
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">ACCESIBILITY</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">PRIVACY POLICY</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">TERMS OF USE</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">COOKIE NOTICE</Button>
            </Grid2>
            <Grid2 item xs={12} md={2}>
              <Button className="social-button">SITE MAP</Button>
            </Grid2>
            <Grid2 item xs={12} md={2} className="logo-buttons">
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="white" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"></path></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path><path fill="white" d="M12 4c.855 0 1.732.022 2.582.058l1.004.048l.961.057l.9.061l.822.064a3.8 3.8 0 0 1 3.494 3.423l.04.425l.075.91c.07.943.122 1.971.122 2.954s-.052 2.011-.122 2.954l-.075.91l-.04.425a3.8 3.8 0 0 1-3.495 3.423l-.82.063l-.9.062l-.962.057l-1.004.048A62 62 0 0 1 12 20a62 62 0 0 1-2.582-.058l-1.004-.048l-.961-.057l-.9-.062l-.822-.063a3.8 3.8 0 0 1-3.494-3.423l-.04-.425l-.075-.91A41 41 0 0 1 2 12c0-.983.052-2.011.122-2.954l.075-.91l.04-.425A3.8 3.8 0 0 1 5.73 4.288l.821-.064l.9-.061l.962-.057l1.004-.048A62 62 0 0 1 12 4m0 2c-.825 0-1.674.022-2.5.056l-.978.047l-.939.055l-.882.06l-.808.063a1.8 1.8 0 0 0-1.666 1.623C4.11 9.113 4 10.618 4 12s.11 2.887.227 4.096c.085.872.777 1.55 1.666 1.623l.808.062l.882.06l.939.056l.978.047c.826.034 1.675.056 2.5.056s1.674-.022 2.5-.056l.978-.047l.939-.055l.882-.06l.808-.063a1.8 1.8 0 0 0 1.666-1.623C19.89 14.887 20 13.382 20 12s-.11-2.887-.227-4.096a1.8 1.8 0 0 0-1.666-1.623l-.808-.062l-.882-.06l-.939-.056l-.978-.047A61 61 0 0 0 12 6m-2 3.575a.6.6 0 0 1 .819-.559l.081.04l4.2 2.424a.6.6 0 0 1 .085.98l-.085.06l-4.2 2.425a.6.6 0 0 1-.894-.43l-.006-.09z"></path></g></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="white" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37z"></path></svg>
              </Button>
              <Button className="logo-button">
              <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20"><path fill="white" fillRule="evenodd" d="M18.896 0H1.104C.494 0 0 .494 0 1.104v17.792C0 19.506.494 20 1.104 20h9.578v-7.745H8.076V9.237h2.606V7.01c0-2.584 1.578-3.99 3.883-3.99c1.104 0 2.052.082 2.329.119v2.7h-1.598c-1.254 0-1.496.596-1.496 1.47v1.927h2.989l-.39 3.018h-2.6V20h5.097c.61 0 1.104-.494 1.104-1.104V1.104C20 .494 19.506 0 18.896 0"></path></svg>
              </Button>
            </Grid2>
          </Grid2>
        </div>
      </div>
    </div>
    );
};
export default Service;